import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { AccountPageComponent } from './account-page/account-page.component';
import { AgencyPageComponent } from './agency-page/agency-page.component';
import { AvcInvoicesComponent } from './avc-invoices/components/avc-invoices.component';
import { InventoryPageComponent } from './inventory-page/inventory-page.component';
import { DocumentsComponent } from './invoices/documents/documents.component';
import { InvoicesPageComponent } from './invoices/invoices-page/invoices-page.component';
import { ProvidersComponent } from './invoices/providers-table/providers-table.component';
import { SegmentsComponent } from './invoices/segments/segments.component';
import { SegmentsBarChartComponent } from './invoices/segments-bar-chart/segments-bar-chart.component';
import { SegmentsFiltersComponent } from './invoices/segments-filters/segments-filters.component';
import { OrdersPageComponent } from './orders-page/orders-page.component';
import { ProfilePageComponent } from './profile-page/profile-page.component';
import { AppRoutingModule } from '../../app-routing.module';
import { TabbedViewModule, SpinnerModule, TitleBarModule, ExceptionsModule, StoreProviderModule, DfMonthPickerModule, PipesModule } from '@uxdf/direct-shared-lib';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbCompatModule } from '@uxdf/direct-shared-lib';
import { DfAlertModule, DfMediaModule, DfSelectModule } from '@design-factory/design-factory';
import { DoughnutChartModule } from '../../directives/doughnutChart.module';
import { ReefAppModule, ReefI18nModule, ReefCurrencyPipe } from '@seco/core';
import { CsvModule } from '@ctrl/ngx-csv';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NavbarModule, FormGroupModule } from '@uxdf/p-components';
import {YearMonthPipe} from '../../pipes/year-month.pipe';
@NgModule({
  declarations: [AccountPageComponent,
    AgencyPageComponent,
    AvcInvoicesComponent,
    InventoryPageComponent,
    OrdersPageComponent,
    ProfilePageComponent,
    DocumentsComponent,
    InvoicesPageComponent,
    ProvidersComponent,
    SegmentsComponent,
    SegmentsBarChartComponent,
    SegmentsFiltersComponent,
    YearMonthPipe
  ],
  providers: [ CurrencyPipe, ReefCurrencyPipe ],
  imports: [
    CommonModule,
    AppRoutingModule,
    TabbedViewModule,
    NgSelectModule,
    SpinnerModule,
    NgbCompatModule,
    FormsModule, 
    TitleBarModule,
    ReactiveFormsModule,
    PipesModule,
    FormGroupModule,
    ReefI18nModule,
    DfMonthPickerModule,
    NavbarModule,
    NgxPageScrollModule,
    StoreProviderModule,
    ExceptionsModule,
    DfSelectModule,
    CsvModule,
    DfMediaModule,
    ReefAppModule.forRoot(),
    DoughnutChartModule,
    DfAlertModule
  ]
})
export class AccountModule {}